import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  AbstractControl, UntypedFormArray, UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors, Validators,
} from "@angular/forms";
import {SharedService} from "../../../../shared/shared.service";
import {CoreService} from "../../../../../services/core/core.service";
import {DialogService} from "../../../../../services/core/dialog.service";
import {first, pairwise, startWith} from "rxjs/operators";
import {BackendApiService} from "../../../../../services/backend-api.service";
import {formatDate} from "@angular/common";
import { ALLOWED_UPLOAD_EXTENSIONS_DOTTED } from "../../../../shared/upload-file-types.constants";

@Component({
    selector: 'app-subcontractor-certificate-form',
    templateUrl: './subcontractor-certificate-form.component.html',
    styleUrls: ['./subcontractor-certificate-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SubcontractorCertificateFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => SubcontractorCertificateFormComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SubcontractorCertificateFormComponent implements OnInit {

  @Input() model: any = {};
  @Input() form: any = {};
  @Input() isEdit: boolean = false;
  @Output() callback = new EventEmitter<any>(true);
  @Output() onInitForm = new EventEmitter<any>(true);
  //@ts-ignore
  public subcontractorCertificateFormSubscription: Subscription;
  public allCertificates: [] = [];
  fileTypes = ALLOWED_UPLOAD_EXTENSIONS_DOTTED;

  public subcontractorCertificateForm: UntypedFormGroup = new UntypedFormGroup({
    certificates: new UntypedFormArray([])
  });

  constructor(
    public sharedService: SharedService,
    public coreService: CoreService,
    public dialogService: DialogService,
    public fb: UntypedFormBuilder,
    public backendApiService: BackendApiService,
  ) {
  }


  ngOnChanges(changes: SimpleChanges) {
    this.model = changes?.model?.currentValue;
    /*if(this.model) {
      this.setDataOnEdit();
    }*/
  }

  ngOnInit(): void {
    this.initSubscriptions();
    this.getCertificates();
  }

  getCertificates = () => {
    this.backendApiService.getApi('certificates/active')
      .subscribe((data: any) => {
          this.allCertificates = data.data;
          if(!this.isEdit){
            this.allCertificates?.map((certificate: any, index: number) => {
              this.addCertificate(certificate);
            });
          }
        });
  }


  certificates(): UntypedFormArray {
    return this.subcontractorCertificateForm?.get('certificates') as UntypedFormArray
  }

  addCertificate(certificate: any = null) {
    this.certificates().push(this.newCertificate(certificate));
  }

  removeCertificate(i: number) {
    this.certificates().removeAt(i);
  }

  removeAllCertificates() {
    this.certificates().clear();
  }

  /*newCertificate(certificate: any = null): UntypedFormGroup {
    const expirationValidation = (certificate && certificate?.is_expiration)  ? [Validators.required ] : [];
    const fileValidation = (certificate && certificate?.is_fle_uploaded)  ? [Validators.required ] : [];
    return this.fb.group({
      is_certified: new UntypedFormControl(false),
      id: new UntypedFormControl(certificate ? certificate?.id : null),
      name: new UntypedFormControl(certificate ? certificate?.name : null),
      // expiration_date: new UntypedFormControl(null, expirationValidation),
      expiration_date: new UntypedFormControl(null, [Validators.required ]),
      is_expiration: new UntypedFormControl(certificate ? certificate?.is_expiration : null),
      is_file_uploaded: new UntypedFormControl(certificate ? certificate?.is_fle_uploaded : null),
      // file_id: new UntypedFormControl('',fileValidation),
      file_id: new UntypedFormControl('', [Validators.required ]),
      // certificate_file: new UntypedFormControl(null),
    })
  }*/

  newCertificate(certificate: any = null): UntypedFormGroup {
    const expirationValidation = (certificate && certificate?.is_expiration) ? [Validators.required] : [];
    const fileValidation = (certificate && certificate?.is_file_uploaded) ? [Validators.required] : [];
    const controlsConfig = {

      is_certified: new UntypedFormControl(  false),
      id: new UntypedFormControl(certificate ? certificate?.id : null),
      name: new UntypedFormControl(certificate ? certificate?.name : null),
      expiration_date: new UntypedFormControl(certificate?.is_expiration && certificate?.pivot?.expire_at ? formatDate(certificate?.pivot?.expire_at,'yyyy-MM-dd','en_US') : null),
      is_expiration: new UntypedFormControl(certificate ? certificate?.is_expiration : null),
      is_file_uploaded: new UntypedFormControl(certificate ? certificate?.is_file_uploaded : null),
      file_id: new UntypedFormControl(certificate?.is_file_uploaded && certificate?.pivot ? certificate?.pivot?.file?.id : null),
      attachment: new UntypedFormControl(certificate?.is_file_uploaded && certificate?.pivot ? certificate?.pivot?.file : null),
    };

    const certificateFormGroup = this.fb.group(controlsConfig);

    // Subscribe to is_certified changes to update expiration_date validation
    certificateFormGroup.get('is_certified')?.valueChanges.subscribe((value) => {
      if (value === true) {
        if(certificate?.is_expiration) {
          certificateFormGroup.get('expiration_date')?.setValidators([Validators.required]);
        }
        if(certificate.is_file_uploaded) {
          certificateFormGroup.get('file_id')?.setValidators([Validators.required]);
        }
      } else {
        if(!certificate?.is_expiration) {
          certificateFormGroup.get('expiration_date')?.clearValidators();
        }
        if(!certificate.is_file_uploaded) {
          certificateFormGroup.get('file_id')?.clearValidators();
        }
      }
      certificateFormGroup.get('expiration_date')?.updateValueAndValidity();
      certificateFormGroup.get('file_id')?.updateValueAndValidity();
    });
    console.log('certificate?.pivot?.is_selected', certificate?.pivot?.is_selected)
    certificateFormGroup.get('is_certified')?.setValue(certificate?.pivot?.is_selected ? true : false);

    return certificateFormGroup;
  }



  ngAfterViewInit(): void {
    this.setDataOnEdit();
    setTimeout(() => {
    }, 500);
  }

  setDataOnEdit = () => {
    if (this.isEdit) {
      this.model?.certificates.map((certificate:any,index: any) => {
        this.addCertificate(certificate);
        this.certificates().at(index)?.get('expiration_date')?.updateValueAndValidity();
        this.certificates().at(index)?.get('file_id')?.updateValueAndValidity();
      })
      // this.closeCertificates();
    }
  }

  closeCertificates(){
    setTimeout(() => {
    this.model?.certificates.map((certificate:any,index: any) => {
      this.certificates().at(index).get('is_certified')?.setValue(false);
    })
    }, 800);
  }

  public onTouched: () => void = () => {
  };

  writeValue(val: any): void {
    val && this.subcontractorCertificateForm.setValue(val, {emitEvent: false});
  }

  registerOnChange(fn: any): void {
    this.subcontractorCertificateForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.subcontractorCertificateForm.disable() : this.subcontractorCertificateForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return this.subcontractorCertificateForm.valid ? null : {
      invalidForm: {
        valid: false,
        message: "Subcontractor fields are invalid"
      }
    };
  }

  initSubscriptions() {
    if (this.form) {
      this.subcontractorCertificateFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched) {
            this.touchFormControls();
          }
        });
    }

  }

  attachment(event: any, index: any) {
    const value = event?.attachment;
    const attachment_id = value?.attachment_id ? value?.attachment_id :value?.id;
    this.certificates().at(index)?.get('attachment')?.setValue(value?.attach_file);
    this.certificates().at(index).get('file_id')?.setValue(attachment_id);
  }

  touchFormControls() {
    Object.keys(this.subcontractorCertificateForm.controls).forEach(key => {
      this.subcontractorCertificateForm.get(key)?.markAsTouched();
    });
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subcontractorCertificateFormSubscription?.unsubscribe();
  }

  addValidationToCertificate(event: any, index: any) {
    const isCertified = this.certificates().at(index).get('is_certified')?.value;
    const isExpirationDate = this.certificates().at(index).get('is_expiration')?.value;
    const isFileUpload = this.certificates().at(index).get('is_file_uploaded')?.value;
    const value = event?.checked;
    // this.certificates().at(index).get('is_certified')?.valueChanges.subscribe((value) => {
      console.log('addValidationToCertificate',value);

      if (value === true && isExpirationDate == 1) {
        this.certificates().at(index).get('expiration_date')?.setValidators([Validators.required]);
      } else {
        this.certificates().at(index).get('expiration_date')?.clearValidators();
      }

      if (value === true && isFileUpload == 1) {
        this.certificates().at(index).get('file_id')?.setValidators([Validators.required]);
      } else {
        this.certificates().at(index).get('file_id')?.clearValidators();
      }
      // Update validation status
      this.certificates().at(index)?.get('expiration_date')?.updateValueAndValidity();
      this.certificates().at(index)?.get('file_id')?.updateValueAndValidity();
    // });

  }
  onDeleteCertificateFile(i: any){
    this.certificates().at(i)?.get('attachment')?.setValue(null);
    this.certificates().at(i)?.get('file_id')?.setValue(null);
    this.certificates().at(i)?.get('file_id')?.updateValueAndValidity();
  }

}
